import React, { Component } from "react";
import Swal from "sweetalert2";

class ModalPrecertificado extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Información del producto</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Producto: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="id"
                      id="producto_id"
                      onChange={(e) =>
                        this.props.component.handleChangeProducto(e)
                      }
                      value={this.props.state.producto.id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.option_productos.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre_comercial}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={"form-group col-lg-3"}>
                  <div className="form-group">
                    <label>
                      Presentación: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="presentacion_id"
                      id="presentacion_id"
                      onChange={(e) =>
                        this.props.component.handleChangeProducto(e)
                      }
                      value={this.props.state.productos.presentacion_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.presentaciones.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.empaque} ({option.cantidad}{" "}
                          {option.unidad_medida})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Cantidad: <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.producto.cantidad}
                      name="cantidad"
                      maxLength={7}
                      onChange={(e) =>
                        this.props.component.handleChangeProducto(e)
                      }
                      className="form-control"
                      id="cantidad"
                      title="Cantidad que se va a exportar de la presentación"
                      placeholder="##"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Kilogramos: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.producto.kilogramos}
                      name="kilogramos"
                      maxLength={6}
                      onChange={(e) =>
                        this.props.component.handleChangeProducto(e)
                      }
                      className="form-control"
                      id="kilogramos"
                      title="Total de kilogramos en el envio"
                      placeholder="##.##"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                  <button
                    type="button"
                    className="btn btn-info col-md-12"
                    onClick={this.props.component.addProducto}
                  >
                    +
                  </button>
                </div>
              </div>
              <div
                  className={
                    this.props.state.productos.length > 0 ? "row" : "row hide"
                  }
                >
                  <hr></hr>
                  <div className="col-md-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Número de registro</th>
                          <th>Nombre comercial</th>
                          <th>Presentación</th>
                          <th>Cantidad</th>
                          <th>Kilogramos</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.productos.length > 0
                          ? this.props.state.productos.map((pro, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{pro.no_registro}</td>
                                <td>{pro.nombre_comercial}</td>
                                <td>
                                  {pro.presentacion} (
                                  {pro.presentacion_cantidad}{" "}
                                  {pro.presentacion_unidad_medida})
                                </td>
                                <td>{pro.cantidad}</td>
                                <td>{pro.kilogramos}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={
                                      this.props.component.removeProducto
                                    }
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={
                                        this.props.component.removeProducto
                                      }
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
          </fieldset>

          <hr></hr>
          <fieldset className="panel">
            <legend>Información destino</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Planta destino: <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.destino.planta_destino}
                      name="planta_destino"
                      maxLength={150}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="planta_destino"
                      title="Planta destino"
                      placeholder="Planta destino"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Nombre del conductor:{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.destino.nombre_conductor}
                      name="nombre_conductor"
                      maxLength={30}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="nombre_conductor"
                      title="Nombre del conductor"
                      placeholder="Nombre del conductor"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Apellido del conductor:{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.destino.apellido_conductor}
                      name="apellido_conductor"
                      maxLength={30}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="apellido_conductor"
                      title="Apellido del conductor"
                      placeholder="Apellido del conductor"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Cédula del conductor:{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.destino.cedula}
                      name="cedula"
                      maxLength={100}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="cedula"
                      title="Cédula del conductor"
                      placeholder=" Cédula del conductor"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Medio de transporte :{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="medio_transporte_id"
                      id="medio_transporte_id"
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      value={this.props.state.destino.medio_transporte_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.medio_transportes.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Número de placa: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.destino.no_placa}
                      name="no_placa"
                      maxLength={15}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="no_placa"
                      title="Número de placa"
                      placeholder="Número de placa"
                    />
                  </div>
                </div>
                {/* <div className="col-lg-3">
                  <div className="form-group">
                    <label>Número de marchamo: </label>
                    <input
                      type="text"
                      value={this.props.state.destino.no_marchamo}
                      name="no_marchamo"
                      maxLength={30}
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      className="form-control"
                      id="no_marchamo"
                      title="Número de marchamo"
                      placeholder="Número de marchamo"
                    />
                  </div>
                </div> */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Departamento</label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={(e) =>
                        this.props.component.handleChangeConductor(e)
                      }
                      name="departamento_id"
                      id="departamento_id"
                      className="form-control m-b-5"
                      value={this.props.state.destino.departamento_id}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.props.state.locations.departamentos.map(
                        (option, index) => (
                          <option
                            key={index}
                            className="dropdown-item"
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Municipio: </label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={(e) => this.props.component.handleChangeConductor(e)}
                      name="ciudad"
                      id="ciudad"
                      className="form-control m-b-5"
                      value={this.props.state.destino.ciudad}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.props.state.locations.municipios
                        .filter(
                          (e) => e.estado_id === this.props.state.destino.departamento_id
                        )
                        .map((option) => (
                          <option
                            className="dropdown-item"
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModal(1);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="submit"
              className="btn btn-success btn-block"
              onClick={(e) => {
                this.props.component.handleSubmit(e);
              }}
            >
              Continuar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalPrecertificado;
